module.exports = __webpack_public_path__ + "static/media/language.9998202d.svg";